import React, { createContext, useState } from "react";
import { AlertModal } from "../components/Shared/AlertModal";
import { ModalCustom } from "../components/Shared/ModalCustom/ModalCustom";

export const UIContext = createContext();

export function UIProvider({ children }) {
  // Alert State
  const [alertData, setAlertData] = useState({
    isOpen: false,
    title: "",
    message: "",
    type: "info",
    onClose: null,
  });

  // Confirm State
  const [confirmData, setConfirmData] = useState({
    isOpen: false,
    title: "",
    message: "",
    onConfirm: null,
    onCancel: null,
    confirmText: "Confirmar",
    cancelText: "Cancelar",
    isDanger: false,
  });

  const showAlert = (title, message, type = "info", onClose = null) => {
    setAlertData({
      isOpen: true,
      title,
      message,
      type,
      onClose,
    });
  };

  const closeAlert = () => {
    if (alertData.onClose) alertData.onClose();
    setAlertData((prev) => ({ ...prev, isOpen: false }));
  };

  const showConfirm = (title, message, onConfirm, options = {}) => {
    setConfirmData({
      isOpen: true,
      title,
      message,
      onConfirm,
      onCancel: options.onCancel || null,
      confirmText: options.confirmText || "Confirmar",
      cancelText: options.cancelText || "Cancelar",
      isDanger: options.isDanger || false,
    });
  };

  const closeConfirm = () => {
    setConfirmData((prev) => ({ ...prev, isOpen: false }));
  };

  const handleConfirm = () => {
    if (confirmData.onConfirm) confirmData.onConfirm();
    closeConfirm();
  };

  const handleCancelConfirm = () => {
    if (confirmData.onCancel) confirmData.onCancel();
    closeConfirm();
  };

  return (
    <UIContext.Provider value={{ showAlert, showConfirm }}>
      {children}
      
      {/* Centralized Alert Modal */}
      <AlertModal
        isOpen={alertData.isOpen}
        title={alertData.title}
        message={alertData.message}
        type={alertData.type}
        onClose={closeAlert}
      />

      {/* Centralized Confirm Modal */}
      <ModalCustom isVisible={confirmData.isOpen} onClose={handleCancelConfirm} size="s">
        <div className="p-6 text-center">
          {confirmData.isDanger ? (
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          ) : (
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
              <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          )}
          <h3 className="text-lg font-bold text-gray-900 mb-2">{confirmData.title}</h3>
          <p className="text-sm text-gray-500 mb-6">{confirmData.message}</p>
          <div className="flex gap-3 justify-center">
            <button
              onClick={handleCancelConfirm}
              className="px-4 py-2 bg-gray-100 text-gray-700 font-medium rounded-xl hover:bg-gray-200 transition-colors"
            >
              {confirmData.cancelText}
            </button>
            <button
              onClick={handleConfirm}
              className={`px-4 py-2 font-medium rounded-xl text-white transition-colors ${
                confirmData.isDanger ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-900 hover:bg-gray-800'
              }`}
            >
              {confirmData.confirmText}
            </button>
          </div>
        </div>
      </ModalCustom>
    </UIContext.Provider>
  );
}
